import { create } from '@wix/fedops-logger';

export const fedopsLogger = create('wix-help-widget-client');
